export class BreadcrumbsApi {
  constructor(route) {
    this.route = route
  }

  getBreadcrumbs() {
    if (this.route) {
      // If report details
      if (this.route.name === 'Report Details') {
        return [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'ACMF Reports',
            to: '/reports',
          },
          {
            text: ` Report ${this.route.params.reportId} - ${this.route.params.tailNumber}`,
          },
        ]
      }

      // if Mx Recs
      if (this.route.name === 'Mx Recs') {
        return [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Maintenance Issues',
            to: '/maintenance',
          },
          {
            text:
              this.route.params.issueId === '-1'
                ? ''
                : ` ${this.route.params.issueId}`,
          },
        ]
      }

      if (this.route.name === 'Custom Analytic') {
        return [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Custom Analytics',
            to: '/custom-analytics',
          },
          {
            text: ` ${
              this.route.params.alertType === 'fullflight'
                ? 'Set a Full Flight Data Analytic'
                : this.route.params.alertType === 'advanced-acmf'
                ? 'Set an Advanced Logic ACMF Data Analytic'
                : this.route.params.alertType === 'advanced-fullflight'
                ? 'Set an Advanced Logic Full Flight Data Analytic'
                : this.route.params.alertType === 'advanced-dplf'
                ? 'Set an Advanced Logic Fault Code Data Analytic'
                : 'Set an ACMF Data Analytic'
            }`,
          },
        ]
      }

      // any other route
      return this.route.meta.breadcrumbs
    }
    return []
  }
}
